import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams ,
            LoadingController, Loading, AlertController } from 'ionic-angular';

import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DatabaseProvider } from '../../providers/database/database';
import { UIProvider } from '../../providers/ui/ui';


import { ProductionItem } from '../production/productionitem';

/**
 * Generated class for the ProductionAddPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-production-add',
  templateUrl: 'production-add.html',
})
export class ProductionAddPage {

  productionForm: FormGroup;
  loading: Loading;

  constructor(public navCtrl: NavController, public navParams: NavParams,  
    public formBuilder: FormBuilder, public alertCtrl: AlertController,
    public loadingCtrl: LoadingController, public dbProvider: DatabaseProvider,
    public uiProvider: UIProvider) {

    this.productionForm = formBuilder.group({
      date: ['', Validators.compose([Validators.required])],
      palmoil: ['', Validators.compose([Validators.required])],
      kerneloil: ['', Validators.compose([Validators.required])],
      kernelcake: ['', Validators.compose([Validators.required])],
      notes: ['', Validators.compose([Validators.minLength(5)])]
    });
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad ProductionAddPage');
  }


  saveProduction() {
    console.log('ionViewDidLoad ProductionAddPage saveProduction(...)');
    if (!this.productionForm.valid){
      console.log(this.productionForm.value);
      console.log('ProductionAddPage user entry invalid(...)');
    } else {
      let aProductionItem : ProductionItem = {
        date : this.productionForm.value.date,
        palmoil : this.productionForm.value.palmoil,
        kerneloil : this.productionForm.value.kerneloil,
        kernelcake : this.productionForm.value.kernelcake,
        notes : this.productionForm.value.notes,

        id : this.dbProvider.getDBId()
      }

      console.log('saving... ' + aProductionItem);
      this.dbProvider.saveProductionItem(aProductionItem);
      this.uiProvider.presentToast( "Saved production of " +  + aProductionItem.date, 3000);
      this.navCtrl.pop();
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/production-add/production-add.ts